module.exports = __webpack_public_path__ + "static/media/telbg.a615aa96.png";